import { SVGProps, Ref, forwardRef } from 'react';

export const PauseOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.7 18V6c0-1.151-.049-1.2-1.2-1.2S6.3 4.849 6.3 6v12c0 1.151.049 1.2 1.2 1.2s1.2-.049 1.2-1.2m9 0V6c0-1.151-.049-1.2-1.2-1.2s-1.2.049-1.2 1.2v12c0 1.151.049 1.2 1.2 1.2s1.2-.049 1.2-1.2m-7.2 0c0 2.625-.375 3-3 3s-3-.375-3-3V6c0-2.625.375-3 3-3s3 .375 3 3zm9 0c0 2.625-.375 3-3 3s-3-.375-3-3V6c0-2.625.375-3 3-3s3 .375 3 3z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PauseOutlinedSize24Glyph.displayName = 'PauseOutlinedSize24Glyph';
